import { createRootRoute, createRoute } from '@tanstack/react-router';
import { RootLayout } from '@/components/layout/RootLayout';
import { HomePage } from '@/pages/Home';
import { DreamsPage } from '@/pages/Dreams';
import { DreamDetailPage } from '@/pages/DreamDetail';
import { NewDreamPage } from '@/pages/NewDream';
import { SubconsciousPage } from '@/pages/Subconscious';
import { SubconsciousChatPage } from '@/pages/SubconsciousChat';
import { SymbolsPage } from '@/pages/Symbols';
import { ProfilePage } from '@/pages/Profile';
import { LoginPage } from '@/pages/Login';
import { MagicLinkPage } from '@/pages/MagicLink';
import { SignupPage } from '@/pages/Signup';
import { TermsPage } from '@/pages/legal/Terms';
import { PrivacyPage } from '@/pages/legal/Privacy';
import { CookiesPage } from '@/pages/legal/Cookies';
import { FaqPage } from '@/pages/legal/Faq';

// Root route with layout
const rootRoute = createRootRoute({
  component: RootLayout,
});

// Public routes
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signup',
  component: SignupPage,
});

const magicLinkRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/magic',
  component: MagicLinkPage,
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
});

const symbolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/symbols',
  component: SymbolsPage,
});

const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: TermsPage,
});

const privacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy',
  component: PrivacyPage,
});

const cookiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cookies',
  component: CookiesPage,
});

const faqRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/faq',
  component: FaqPage,
});

// Protected routes (auth required)
const dreamsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams',
  component: DreamsPage,
});

const dreamDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams/$dreamId',
  component: DreamDetailPage,
});

const newDreamRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dreams/new',
  component: NewDreamPage,
});

const subconsciousRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subconscious',
  component: SubconsciousPage,
});

const subconsciousChatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subconscious/$sessionId',
  component: SubconsciousChatPage,
});

const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/profile',
  component: ProfilePage,
});

// Build route tree
export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  magicLinkRoute,
  signupRoute,
  symbolsRoute,
  termsRoute,
  privacyRoute,
  cookiesRoute,
  faqRoute,
  dreamsRoute,
  dreamDetailRoute,
  newDreamRoute,
  subconsciousRoute,
  subconsciousChatRoute,
  profileRoute,
]);
